<template>
  <!-- <div class="father"> -->
  <div class="header" :style="getStyle()">
    <div :class="isPC ? 'main-navigat-bar' : 'm-main-navigat-bar'">
      <div class="imgs">
        <img :src="require('../../../img/home/logo_b@2x.png')" alt="" style="width: auto;height: 100%;">
      </div>
      <div class="icon-shrink" v-if="!isPC" @click="iconShrink()">
        <img
          :src="scrollTop > 1 ? require('../../../img/icon/icon_nav_black.png') : require('../../../img/icon/icon_nav.png')"
          alt="">
      </div>
      <div class="mask-w" @click="itemClick()" v-if="maskFlag">
        <div class="mask" v-if="maskFlag">
          <div class="m-title m-main-navigat-bar">
            <div class="imgs">
              <img :src="require('../../../img/home/logo_w@2x.png')" alt="">
            </div>
            <div class="m-xxx" @click="iconShrink()">
              <img :src="require('../../../img/icon/icon_close.png')" alt="">
            </div>
          </div>
          <div class="m-tab-bar">
            <navigat-bar class="tab-bar">
              <navigat-bar-item path="/layout/home" activeColor="#ffffff" :isPC='isPC'>
                <template v-slot:item-text>
                  <div :class="scrollTop > 1 ? 'noactive-scroll m-t-text' : 'noactive-noscroll m-t-text'"
                    @click="itemClick">首页</div>
                </template>
                <template v-slot:item-text-active>
                  <div class="active m-t-text" @click="itemClick">首页</div>
                </template>
              </navigat-bar-item>

              <navigat-bar-item path="/layout/shopkeeper" activeColor="#ffffff" :isPC='isPC'>
                <div slot="item-text"
                  :class="scrollTop > 1 ? 'noactive-scroll m-t-text' : 'noactive-noscroll m-t-text'"><span
                    @click="itemClick">智慧经营小程序&nbsp;产品中心</span></div>
                <div slot="item-text-active" class="active m-t-text"><span @click="itemClick">智慧经营小程序&nbsp;产品中心</span>
                </div>
              </navigat-bar-item>

              <navigat-bar-item path="/layout/takeout" activeColor="#ffffff" :isPC='isPC'>
                <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll m-t-text' : 'noactive-noscroll m-t-text'"
                  @click="itemClick">餐饮外卖代运营</div>
                <div slot="item-text-active" class="active m-t-text" @click="itemClick">餐饮外卖代运营</div>
              </navigat-bar-item>

              <navigat-bar-item path="/layout/fireCodeScreen" activeColor="#ffffff" :isPC='isPC'>
                <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll m-t-text' : 'noactive-noscroll m-t-text'"
                  @click="itemClick">火码云屏</div>
                <div slot="item-text-active" class="active m-t-text" @click="itemClick">火码云屏</div>
              </navigat-bar-item>

              <navigat-bar-item path="/layout/about" activeColor="#ffffff" :isPC='isPC'>
                <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll m-t-text' : 'noactive-noscroll m-t-text'"
                  @click="itemClick">关于我们</div>
                <div slot="item-text-active" class="active m-t-text" @click="itemClick">关于我们</div>
              </navigat-bar-item>

              <navigat-bar-item path="/layout/about" activeColor="#ffffff" :isPC='isPC'>
                <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll m-t-text' : 'noactive-noscroll m-t-text'"
                  @click="itemClick">合作洽谈</div>
                <div slot="item-text-active" class="active m-t-text" @click="itemClick">合作洽谈</div>
              </navigat-bar-item>
            </navigat-bar>
          </div>
        </div>
      </div>
      <!-- <navigat-bar v-if="isPC" class="tab-bar"> -->
      <!-- 首页组件 -->
      <navigat-bar-item path="/layout/home" :activeColor="'#E0422A'">
        <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll' : 'noactive-noscroll'" @click="scrollToTop()">
          首页
          <div class="arrow-down" />
        </div>
        <div slot="item-text-active" class="active">
          <div class="active">
            首页
            <div class="active-arrow-down" />
          </div>
        </div>
      </navigat-bar-item>

      <navigat-bar-item path="/layout/product" :activeColor="'#E0422A'">
        <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll' : 'noactive-noscroll'" @click="scrollToTop()">
          产品中心
          <div class="arrow-down" />
        </div>
        <div slot="item-text-active" class="active">
          <div class="active">
            产品中心
            <div class="active-arrow-down" />
          </div>
        </div>
      </navigat-bar-item>

      <navigat-bar-item path="/layout/brand" :activeColor="'#E0422A'">
        <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll' : 'noactive-noscroll'" @click="scrollToTop()">
          品牌运营
          <div class="arrow-down" />
        </div>
        <div slot="item-text-active" class="active">
          <div class="active">
            品牌运营
            <div class="active-arrow-down" />
          </div>
        </div>
      </navigat-bar-item>

      <navigat-bar-item path="/layout/development" :activeColor="'#E0422A'">
        <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll' : 'noactive-noscroll'" @click="scrollToTop()">
          开发服务
          <div class="arrow-down" />
        </div>
        <div slot="item-text-active" class="active">
          <div class="active">
            开发服务
            <div class="active-arrow-down" />
          </div>
        </div>
      </navigat-bar-item>

      <navigat-bar-item path="/layout/about" :activeColor="'#E0422A'">
        <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll' : 'noactive-noscroll'" @click="scrollToTop()">
          关于我们
          <div class="arrow-down" />
        </div>
        <div slot="item-text-active" class="active">
          <div class="active">
            关于我们
            <div class="active-arrow-down" />
          </div>
        </div>
      </navigat-bar-item>

      <navigat-bar-item path="/layout/certificate" :activeColor="'#E0422A'">
        <div slot="item-text" :class="scrollTop > 1 ? 'noactive-scroll' : 'noactive-noscroll'" @click="scrollToTop()">
          合作洽谈
          <div class="arrow-down" />
        </div>
        <div slot="item-text-active" class="active">
          <div class="active">
            合作洽谈
            <div class="active-arrow-down" />
          </div>
        </div>
      </navigat-bar-item>
      <!-- </navigat-bar> -->
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
  import NavigatBar from '@/components/NavigatBar/NavigatBar'
  import NavigatBarItem from '@/components/NavigatBar/NavigatBarItem'
  export default {
    name: 'MainNavigatBar',
    components: {
      NavigatBarItem,
      NavigatBar
    },
    data() {
      return {
        maskFlag: false,
        scrollTop: 0,
      }
    },
    mounted() {
      const appElement = document.getElementById('app');
      if (appElement) {
        appElement.addEventListener('scroll', this.scrollHandle);
      }
    },
    beforeDestroy() {
      const appElement = document.getElementById('app');
      if (appElement) {
        appElement.removeEventListener('scroll', this.scrollHandle);
      }
    },
    methods: {
      itemClick() {
        this.maskFlag = false
      },
      iconShrink() {
        // console.log('缩放导航栏')
        this.maskFlag = !this.maskFlag
      },
      scrollHandle(e) {
        this.scrollTop = e.target.scrollTop / 100;
      },
      getStyle() {
        if (this.scrollTop > 3) {
          return `background-color: rgba(255, 255, 255, ${this.scrollTop});box-shadow: 0px 1px 4px rgb(0 0 0 / 20%)`
        }
        if (this.scrollTop > 1) {
          return `background-color: rgba(255, 255, 255, ${this.scrollTop})`
        }
      },
      scrollToTop() {
        const appElement = document.getElementById('app');
        if (appElement) {
          setTimeout(() => {
            this.scrollHandle;
            appElement.scrollTo({
              top: 0,
              behavior: 'auto'
            });
          }, 300);
        }
      }
    },

  }
</script>
<style lang="less" scoped>
  .active {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    vertical-align: middle;
    color: #E0422A;
  }

  .arrow-down {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    width: 0;
    height: 0;
    border-top: 5px solid rgba(17, 17, 17, 0.8);
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    transition: all 0.3s ease;
  }

  .active-arrow-down {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    width: 0;
    height: 0;
    border-top: 5px solid #E0422A;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    transition: transform 0.3s ease;
  }

  .header {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    transition: all 0.6s;
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 1px 4px rgb(0 0 0 / 20%);
  }

  .main-navigat-bar {
    width: 100vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 75px;
    box-sizing: border-box;
    padding: 0 5vw;
  }

  .imgs {
    z-index: 100;
    width: auto;
    height: 34px;
    margin: 18px 50vw 22px 0;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .m-main-navigat-bar {
    width: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;

    .imgs {
      z-index: 100;
      width: 108px;
      height: 16px;
      margin: 16px 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .noactive-noscroll {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    vertical-align: middle;
    color: rgba(17, 17, 17, 0.8);
    transition: all 0.3s;
    cursor: pointer;

    .arrow-down {
      border-top: 5px solid rgba(17, 17, 17, 0.8);
    }
  }

  .noactive-noscroll:hover {
    align-items: center;
    color: #E0422A;

    .arrow-down {
      border-top: 5px solid #E0422A;
    }
  }

  .noactive-scroll {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    vertical-align: middle;
    color: rgba(17, 17, 17, 0.8);
    transition: all 0.3s;
    cursor: pointer;

    .arrow-down {
      border-top: 5px solid rgba(17, 17, 17, 0.8);
    }
  }

  .noactive-scroll:hover {
    align-items: center;
    color: #E0422A;

    .arrow-down {
      border-top: 5px solid #E0422A;
    }
  }

  .user {
    width: 180px;
    height: 40px;
    color: #ffffff;
    border-radius: 4px;
    margin-top: 21px;
    font-size: 16px;
    text-align: center;

    .hover {
      height: 40px;
      line-height: 40px;
      border: 1px solid #ffffff;
    }

    .hover2 {
      height: 40px;
      line-height: 40px;
      border: 1px solid #ffffff;
    }
  }

  .user-scroll {
    width: 180px;
    height: 40px;
    color: #666666;
    border-radius: 4px;
    margin-top: 21px;
    font-size: 16px;
    text-align: center;

    .hover-scroll {
      height: 40px;
      line-height: 40px;
      border: 1px solid #E5E5E5;
    }

    .hover2-scroll {
      height: 40px;
      line-height: 40px;
      border: 1px solid #E5E5E5;
    }
  }

  .hover:hover {
    color: black;
    background-color: #fff;
    border: 1px solid #fff;
  }

  .hover2:hover {
    color: black;
    background-color: #fff;
    border: 1px solid #fff;
  }

  .hover-scroll:hover {
    color: #fff;
    background-color: #E0422A;
    border: 1px solid #E0422A;
  }

  .hover2-scroll:hover {
    color: #fff;
    background-color: #E0422A;
    border: 1px solid #E0422A;
  }

  .icon-shrink {
    width: 24px;
    height: 24px;
    margin: 16px 0;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .mask {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 101;
    background: rgba(24, 29, 43, 0.95);

    .m-tab-bar {
      height: auto;
      margin: 0 15px;

      .m-t-text {
        height: 56px;
        font-size: 16px;
        line-height: 56px;
        padding: 0 15px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.25);
      }
    }
  }

  .mask-w {
    width: 100%;
    height: 99999px;
  }

  @media screen and (max-width: 1669px) {
    .main-navigat-bar {
      padding: 0 4vw;
    }

    .imgs {
      margin-right: 40vw;
    }
  }

  @media screen and (max-width: 1440px) {
    .main-navigat-bar {
      max-width: 1440px;
      margin: 0 auto;
      padding: 0 40px;

      .noactive-noscroll,
      .noactive-scroll,
      .active {
        font-size: 16px;
      }
    }

    .imgs {
      margin-right: 380px;
      height: 34px;
    }
  }

  @media screen and (max-width: 1240px) {
    .main-navigat-bar {
      max-width: 1440px;
      margin: 0 auto;
      padding: 0 40px;

      .noactive-noscroll,
      .noactive-scroll,
      .active {
        font-size: 16px;
      }
    }

    .imgs {
      margin-right: 280px;
      height: 34px;
    }
  }

  @media screen and (max-width: 1024px) {
    .main-navigat-bar {
      padding: 0 3vw;

      .noactive-noscroll,
      .noactive-scroll,
      .active {
        font-size: 14px;
      }

      .arrow-down,
      .active-arrow-down {
        margin-left: 3px;
        border-top-width: 4px;
        border-right-width: 4px;
        border-left-width: 4px;
      }
    }

    .imgs {
      margin-right: 25vw;
      height: 28px;
    }
  }

  @media screen and (max-width: 768px) {
    .main-navigat-bar {
      padding: 0 15px;
    }

    .imgs {
      width: 100px;
      height: 28px;
      margin: 12px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/MainNavigatBar/MainNavigatBar.vue